/**
 * Terms of Use 独立页面
 * 从 AZ_AI_MVR_H5/src/pages/terms-of-use/index.tsx 迁移
 * 替换 ProLayout/PageContainer → 简单布局
 */
import { createStyles } from 'antd-style';
import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import ContainerBg2 from '@/assets/opsmate/bg2.png';
import Agreement from '@/pages/opsmate/components/Agreement';
import PortalLayout from '@/components/layout/PortalLayout';

const useStyles = createStyles(() => ({
  agreementContainer: {
    backgroundImage: `url(${ContainerBg2})`,
    padding: 16,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'left top',
  },
}));

export default function TermsOfUse() {
  const { styles } = useStyles();
  const { t } = useTranslation();

  return (
    <PortalLayout>
        <Flex
          vertical
          style={{ height: 'calc(100vh - 56px)' }}
          gap={10}
          className={styles.agreementContainer}
        >
          <div style={{ flex: 1, overflowY: 'auto', padding: '20px 16px' }}>
            <Agreement />
          </div>
        </Flex>
    </PortalLayout>
  );
}
